import React, { useState } from 'react';
import Tooltip from '../tooltip';
import { useAiChatApiService } from '../../../../api/providers/AppServiceProvider';
import { FilterItem } from '../../../../models/ai-chat/filter-request';
import { FaRegFilePdf } from "react-icons/fa6";
interface PDFDownloadActionProps {
  onDownload?: () => void;
  data?: any;
  messageId?: string;
  filterData?: FilterItem[];
  className?: string;
}

const PDFDownloadAction: React.FC<PDFDownloadActionProps> = ({
  onDownload,
  messageId,
  filterData,
  className = ''
}) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const aiChatApiService = useAiChatApiService();

  const handleDownload = async () => {
    if (!messageId || isDownloading) {
      console.log('PDF Download blocked - messageId:', messageId, 'isDownloading:', isDownloading);
      return;
    }

    setIsDownloading(true);
    
    try {
      // Extract date range from filterData
      let startDate: string | undefined;
      let toDate: string | undefined;
      
      if (filterData && filterData.length > 0) {
        filterData.forEach(filter => {
          if (filter.columnName && filter.columnName.toLowerCase().includes('date')) {
            if (filter.operator === '>=' || filter.operator === '>') {
              startDate = filter.columnValue;
            } else if (filter.operator === '<=' || filter.operator === '<') {
              toDate = filter.columnValue;
            }
          }
        });
      }

      console.log('PDF Download - messageId:', messageId, 'startDate:', startDate, 'toDate:', toDate, 'filterData:', filterData, 'filterDataLength:', filterData?.length);
      const blob = await aiChatApiService.downloadTableAsPDF(messageId, startDate, toDate, filterData);
      
      // Create download link and trigger download with proper filename
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;

      let filename = 'Account_Statement';

      if (startDate && toDate) {
        const cleanStart = startDate.replace(/-/g, '');
        const cleanEnd = toDate.replace(/-/g, '');
        filename += `_${cleanStart}_${cleanEnd}`;
      } else {
        // Use current timestamp if no date range
        const d = new Date();
        const pad = (n: number) => String(n).padStart(2, '0');
        const timestamp = (
          d.getUTCFullYear().toString() +
          pad(d.getUTCMonth() + 1) +
          pad(d.getUTCDate()) +
          '_' +
          pad(d.getUTCHours()) +
          pad(d.getUTCMinutes()) +
          pad(d.getUTCSeconds())
        );
        filename += `_${timestamp}`;
      }

      filename += '.pdf';
      link.setAttribute('download', filename);
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      console.log('PDF download completed successfully with filename:', filename);
    } catch (error) {
      console.error('PDF Download failed:', error);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Tooltip message={isDownloading ? "Downloading..." : "Export PDF"}>
      <button 
        title={isDownloading ? "Downloading..." : "Export PDF"} 
        type="button" 
        onClick={handleDownload} 
        disabled={isDownloading}
        className={`p-2 group flex items-center justify-center rounded-full transition-colors active:text-primary text-primary-text hover:bg-secondary-background hover:text-primary ${isDownloading ? 'opacity-75 cursor-not-allowed' : ''} ${className}`}
      >
        {isDownloading ? (
          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-gray-600"></div>
        ) : (
          <FaRegFilePdf className="w-5 h-5" strokeWidth={0}/>
        )}
      </button>
    </Tooltip>
  );
};

export default PDFDownloadAction;